import { readonly, ref } from 'vue';

const crossOriginDragDestination = ref('');
export const dragDestinationName = readonly(crossOriginDragDestination);
export function enableCrossOriginDrag(destination: string) { crossOriginDragDestination.value = destination; }
